export const REGEXP_DATE_AVEC_MOIS_JOUR_INCONNU =
    /^((00\/00)|((00|(0[1-9]|[1-2][0-9]|3[0-1]))\/(0[1-9]|1[0-2])))\/((19[0-9]{2})|2[0-9]{3})$/;
export const REGEXP_DATE_FR =
    /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/((19[0-9]{2})|2[0-9]{3})$/;
export const REGEXP_DATE_AVEC_ANNEE = /^((19[0-9]{2})|2[0-9]{3})$/;
export const REGEXP_DATE_AVEC_JOUR_MOIS_ANNEE =
    /^((00\/00)|((0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])))\/((19[0-9]{2})|2[0-9]{3})$/;
export const REGEXP_EMAIL = /^[a-zA-Z0-9_.-]+@[a-z0-9_.-]+\.[a-z]{2,63}$/;
export const REGEXP_CODE_POSTAL = /^[0-9]{5}$/;
export const REGEXP_NOM_PRENOM = /^[A-Z '-]+$/;
export const REGEXP_LIEU = /^[A-Z '-]+$/;
export const TAILLE_CAPTCHA = 6;
export const REGEX_RGA = /^[a-zA-Z0-9]{5}$/;
export const REGEX_DEP_GUYANNE_CALEDONIE_POLYNESIE_MAYOTTE =
    /^((973[0-9]{2})|(988[0-9]{2})|(987[0-9]{2})|(976[0-9]{2}))$/;
export const REGEXP_NUMERO_GUICHET_UNIQUE = /^[0-9]{14,}$/;
